import React, { createContext, useContext, useState, type PropsWithChildren } from 'react'
// import type { ApiErrorResponse } from '../types';
import { StorageAdapter } from '../helpers/storage-adapters';


interface AuthContextType {
  isAuthenticated: boolean;
  login: () => void;
  logout: () => void;
}

// Creamos un contexto para compartir el estado de autenticación
const AuthContext = createContext<AuthContextType | null>(null);

// Hook personalizado para acceder fácilmente al contexto de autenticación desde cualquier componente
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de un AuthProvider');
  }
  return context;
};

const primeraVez = (): boolean => {
  const token = StorageAdapter.getItem('token');
  if (token && typeof token === 'string' && token !== '') {
    return true
  }
  return false;
}

// El componente proveedor que envuelve la aplicación
export const AuthProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(primeraVez());

  const login = () => {
    const state = primeraVez();
    setIsAuthenticated(state);
  };

  const logout = async () => {
    // console.log("Usuario ha cerrado sesión.");
    StorageAdapter.removeItem('token');
    setIsAuthenticated(false);
  };

  const value = {
    isAuthenticated,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
